(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["md-gallery-sale-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('md-gallery-sale-badge')) {
  customElements.define('md-gallery-sale-badge', class extends HTMLElement {
    connectedCallback() {
      this.bindUpdates = () => this.connectUpdates();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.bindUpdates, {once:true});
      else this.connectUpdates();
    }
    connectUpdates() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data.sectionId) !== this.dataset.section) return;
        const replacement = Array.from(event.data.html?.querySelectorAll('md-gallery-sale-badge') || []).find(node => node.dataset.section === this.dataset.section);
        if (!replacement) { this.hidden = true; return; }
        this.textContent = replacement.textContent;
        this.hidden = replacement.hidden;
      });
    }
    disconnectedCallback() { document.removeEventListener('DOMContentLoaded', this.bindUpdates); this.unsubscribe?.(); this.unsubscribe = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
